<script setup lang="ts">
import { ref } from 'vue';
import { ModalDialog, PrimaryButton } from '@hfc/ui-core';
import BaseSection from '@/application/shared/infrastructure/components/BaseSection.vue';
import { useUrlHelper } from '@/shared/infrastructure/composition/useUrlHelper';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

const { getSmallBusinessConsultationPhone, getSmallBusinessConsultationLink } = useUrlHelper();
const { smallBusinessState } = useSmallBusinessStore();

const showAppointmentModal = ref<boolean>(false);

const isSmallCompany = smallBusinessState.value.isSmallCompany;

const appointmentLink = getSmallBusinessConsultationLink();

defineExpose({
  sectionSubmit: () => true
});
</script>
<template>
  <BaseSection class="flex-1 items-center text-center">
    <div class="flex flex-col gap-4 lg:gap-6 flex-1 justify-center 2xl:pb-32 max-w-4xl">
      <hfc-icon :icon="['fa', 'calendar-day']" class="text-green-600 text-6xl" />
      <h1 class="text-center text-xl sm:text-5xl mt-8 mx-10">
        Thank you for {{ !smallBusinessState.hasAppointment ? 'submitting' : 'updating' }} your plan selection!
      </h1>
      <div class="mt-5">
        <hr class="max-w-[50%] mx-auto">
        <p v-if="!smallBusinessState.hasAppointment" class="text-lg sm:text-2xl py-5">
          <span v-if="isSmallCompany">
            Please call us to continue the process
          </span>
          <span v-else>
            We will call you for your appointment or for more immediate attention call
          </span>
          <br>
          <a class="ml-2" :href="`tel:${getSmallBusinessConsultationPhone()}`">{{ getSmallBusinessConsultationPhone() }}</a>
        </p>
        <div v-else class="flex flex-col sm:flex-row sm:space-x-4 justify-center items-center">
          <PrimaryButton class="mt-2 mb-3 w-60 justify-center" :href="`tel:${getSmallBusinessConsultationPhone()}`">Call Us</PrimaryButton>
          <PrimaryButton class="mt-2 mb-3 w-60 justify-center" @click="showAppointmentModal = true">Schedule an appointment</PrimaryButton>
        </div>
      </div>
    </div>
  </BaseSection>
  <ModalDialog v-if="showAppointmentModal" :show-confirm-button="false" size="xl" title="Let us help" @close="showAppointmentModal = false">
    <template #content>
      <iframe class="w-full h-full md:min-h-[calc(50vh)] lg:-mt-16" style="zoom: 1.4;" :src="appointmentLink"></iframe>
    </template>
  </ModalDialog>
</template>
